/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeferredIncomeHistoryDtoFinancialPlan
 */
export interface DeferredIncomeHistoryDtoFinancialPlan {
  /**
   *
   * @type {string}
   * @memberof DeferredIncomeHistoryDtoFinancialPlan
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof DeferredIncomeHistoryDtoFinancialPlan
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof DeferredIncomeHistoryDtoFinancialPlan
   */
  createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof DeferredIncomeHistoryDtoFinancialPlan
   */
  from: Date;
  /**
   *
   * @type {Date}
   * @memberof DeferredIncomeHistoryDtoFinancialPlan
   */
  to: Date;
  /**
   *
   * @type {number}
   * @memberof DeferredIncomeHistoryDtoFinancialPlan
   */
  month: number;
  /**
   *
   * @type {number}
   * @memberof DeferredIncomeHistoryDtoFinancialPlan
   */
  year: number;
}

export function DeferredIncomeHistoryDtoFinancialPlanFromJSON(json: any): DeferredIncomeHistoryDtoFinancialPlan {
  return DeferredIncomeHistoryDtoFinancialPlanFromJSONTyped(json, false);
}

export function DeferredIncomeHistoryDtoFinancialPlanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeferredIncomeHistoryDtoFinancialPlan {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
    from: new Date(json["from"]),
    to: new Date(json["to"]),
    month: json["month"],
    year: json["year"],
  };
}

export function DeferredIncomeHistoryDtoFinancialPlanToJSON(value?: DeferredIncomeHistoryDtoFinancialPlan | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
    from: value.from.toISOString(),
    to: value.to.toISOString(),
    month: value.month,
    year: value.year,
  };
}
